<template>
    <span>
        <el-badge style="height: 32px; margin-right: 10px; cursor: pointer;">
            <el-tooltip class="item" effect="dark" :content="`授权状态`" placement="top-start">
                 <AuthIcon @click="handleClick"
                           :success="auth.level === 'success'"
                           :warning="auth.level === 'warning'"
                           :failure="auth.level === 'failure'"
                           :none="view.none"></AuthIcon>
            </el-tooltip>
        </el-badge>

<!--        <el-badge style="height: 32px; margin-right: 10px; cursor: pointer;">-->
<!--            <el-tooltip class="item" effect="dark" :content="`业务链同步`" placement="top-start">-->
<!--                <BizChainIcon @click="handleOnlineRefresh"></BizChainIcon>-->
<!--            </el-tooltip>-->
<!--        </el-badge>-->

      <el-badge style="height: 32px; margin-right: 10px; cursor: pointer;" v-if="auth.updateMark">
            <el-tooltip class="item" effect="dark" :content="`更新提示`" placement="top-start">
                <UpdateIcon @click="handleShowUpdate" :none="view.none"></UpdateIcon>
            </el-tooltip>
        </el-badge>

        <el-dialog close-on-press-escape close-on-click-modal append-to-body v-draggable title="授权信息" :visible.sync="view.visible"
                   width="420px">
            <div class="dialog-button">
                <el-button class="green" icon="el-icon-fa-info-circle" @click="showAuthCode">授权码</el-button>
                <el-button v-if="isOnlineSupport" class="blue" icon="el-icon-fa-clock-o" @click="handleOnlineRefresh">在线同步</el-button>
            </div>

            <div v-loading="view.loading" v-if="view.visible">
                <el-row>
                 <el-col :span="8">
                     <div hideTitle>
                          <AuthIcon @click="handleClick"
                                    :success="auth.level === 'success'"
                                    :warning="auth.level === 'warning'"
                                    :failure="auth.level === 'failure'"
                                    height="120px"
                                    width="120px"
                          ></AuthIcon>
                     </div>
                 </el-col>
                 <el-col :span="16">
                     <div hideTitle style="font-size: 14px;">
                         <div style="margin: 6px;">
                             <span style="color: rgb(154,154,154)">授权状态: </span>
                             <span style="color: #000000">{{ auth.title }}</span>
                         </div>
                         <div style="margin: 6px;">
                             <span style="color: rgb(154,154,154)">开始时间: </span>
                             <span style="color: #000000">{{ simpleFormatterDate(auth.staTime) || '-'}}</span>
                         </div>
                         <div style="margin: 6px;">
                             <span style="color: rgb(154,154,154)">结束时间: </span>
                             <span style="color: #000000">{{ simpleFormatterDate(auth.endTime) || '-'}}</span>
                         </div>
                         <div style="margin: 6px;">
                             <span style="color: rgb(154,154,154)">剩余时间: </span>
                             <span style="color: #000000">{{ simplifyTime() }}</span>
                         </div>
                     </div>
                 </el-col>
                </el-row>

                <div class="login-confirm-custom-body" v-if="auth.suffix">
                    <div v-if="isOnlineSupport">请复制授权码到
                        <a href="http://osp.cnetong.com" target="_blank">企业服务平台</a>
                        {{ auth.suffix }}
                    </div>
                    <div v-else>请复制授权码联系相关人员{{ auth.suffix }}
                    </div>
                    <div class="auth">
                        <span class="label">授权码</span>
                        <span class="code">{{ auth.authCode }}</span>
                        <i class="el-icon-copy-document" id="login-clock-copy" title="复制授权码" @click="copy"></i>
                    </div>
                </div>
            </div>
        </el-dialog>

      <el-dialog close-on-press-escape close-on-click-modal append-to-body v-draggable title="更新信息" :visible.sync="updateview.visible"
                 width="420px">
            <div class="dialog-button">
                <el-button class="blue" icon="el-icon-fa-check-circle " @click="handleDoUpdate">确认更新</el-button>
            </div>

            <div v-loading="view.loading" v-if="updateview.visible">
              <UpdateInfoShow v-model="auth"></UpdateInfoShow>
            </div>
        </el-dialog>
    </span>
</template>

<script>
  import HeaderApi from '../Header';
  import AuthIcon from "./auth/AuthIcon.vue";
  import BizChainIcon from "./bizChain/BizChainIcon.vue";
  import UpdateIcon from "./update/UpdateIcon.vue";
  import UpdateInfoShow from "./update/UpdateInfoShow.vue";

  export default {
    name: "Header",
    components: {AuthIcon, BizChainIcon, UpdateIcon, UpdateInfoShow},
    data: () => ({
      auth: {
        authCode: '',
        authorized: false,
        staTime: 0,
        endTime: 0,
        serverTime: 0,
        status: '',
        //bizChainSynchronized: true,
        // 更新信息
        updateMark: false,
        versionName: '',
        versionNo: '',
        updateDate: '',
        versionSize: '',
        md5: '',
        // 以下为本页计算得到的
        title: '',
        suffix: '',
        level: 'none',
      },
      view: {
        visible: false,
        loading: false,
        none: false,
      },
      updateview: {
        visible: false,
        loading: false,
        none: false,
      },
      queryInterval: null,
      starInterval: null,
      isOnlineSupport:false
    }),
    computed: {},
    created: function () {
      HeaderApi.isOnlineSupport().then(resp=>{
        this.isOnlineSupport = resp.isOnlineSupport;
      })

    },
    mounted() {
      this.handleQuery();
      this.queryInterval = setInterval(this.handleQuery, 10000);
      this.starInterval = setInterval(() => {
        this.view.none = !this.view.none;
      }, 700);
    },
    beforeDestroy() {
      clearInterval(this.starInterval);
      clearInterval(this.queryInterval);
    },
    methods: {
      async handleClick() {
        this.view.visible = true;
        await this.handleQuery();
      },
      copy() {
        let aux = document.createElement("input");
        aux.setAttribute("value", this.authCode);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        this.$message.success("复制成功")
      },
      simplifyTime() {
        if (!this.auth.endTime) {
          return '未授权'
        }
        let nanoTime = this.auth.endTime - this.auth.serverTime
        if (nanoTime < 1000) {
          return '已到期'
        }
        let m = (nanoTime / 1000 / 60).toFixed()
        if (m < 120) {
          return `${m} 分钟`
        }
        let h = (m / 60).toFixed();
        if (h < 48) {
          return `${h} 小时`;
        }
        return `${(h / 24).toFixed()} 天`;
      },
      async handleQuery() {
        try {
          this.view.loading = true;

          let resp = await HeaderApi.getInfo();
          Object.assign(this.auth, resp.data);
          this.computedAuthData();
        }catch (ex){
          this.$router.push("/login");
        }finally {
          this.view.loading = false;
        }
      },
      async handleOnlineRefresh() {
        try {
          this.view.loading = true;
          await HeaderApi.onlineRefresh();
          await this.handleQuery();
          this.$message.success('在线同步已完成')
        } finally {
          this.view.loading = false;
        }
      },
      computedAuthData() {
        if (this.auth.authorized && this.auth.status === '1') {
          this.auth.title = '授权成功';
          this.auth.suffix = null;
          //this.auth.title = '授权不存在';
          //this.auth.suffix = '申请授权';
        } else if (this.auth.status === '6') {
          this.auth.title = '授权不存在';
          this.auth.suffix = '申请授权';
        } else if (this.auth.status === '7') {
          this.auth.title = '授权申请未审批';
          this.auth.suffix = '查看审批进度';
        } else if (this.auth.status === '8') {
          this.auth.title = '授权申请未通过';
          this.auth.suffix = '申请授权';
        } else if (this.auth.status === '9') {
          this.auth.title = '授权变更申请未审批';
          this.auth.suffix = '查看审批进度';
        } else if (this.auth.status === '10') {
          this.auth.title = '授权变更申请未通过';
          this.auth.suffix = '申请授权';
        } else if (this.auth.status === '11') {
          this.auth.title = '授权已超期';
          this.auth.suffix = '申请授权';

        } else if (this.auth.status === '12') {
          this.auth.title = '授权延期申请未审批';
          this.auth.suffix = '查看审批进度';
        } else if (this.auth.status === '13') {
          this.auth.title = '授权延期申请未通过';
          this.auth.suffix = '申请授权';
        } else if (this.auth.status === '14') {
          this.auth.title = '授权已禁用';
          this.auth.suffix = '反馈问题';
        } else {
          this.auth.title = '授权状态异常 - ' + this.auth.status;
          this.auth.suffix = '反馈问题';
        }
        if( this.auth.status !== '1'){
          this.$router.push("/login");
        }
        if (!this.auth.authorized || this.auth.serverTime > this.auth.endTime) {
          this.auth.level = "failure";
        } else if (this.auth.endTime - this.auth.serverTime < 24 * 60 * 60 * 1000 * 15) {
          this.auth.level = "warning";
        } else {
          this.auth.level = "success";
        }
      },
      // 展示更新信息
      handleShowUpdate() {
        this.updateview.visible = true;
        this.handleQuery();
      },
      async handleDoUpdate() {
        await this.confirm(null, "确认要停止程序，开始更新吗？");
        // 开始更新
        let loading = this.$loading({
          lock: true,
          text: '正在更新...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        try {
          let resp = await HeaderApi.onlineUpdate();
          if (resp.respCode !== '000000') {
            loading.close();
          }
        }catch (e) {
          loading.close();
        }
      },
      // 显示当前授权码
      showAuthCode(){
        this.$alert(this.auth.authCode, '授权码', {
          confirmButtonText: '关闭',
          callback: action => { }
        });
      }
    }
  }
</script>


<style scoped lang="scss">
  .login-confirm-custom-body {

    div {
      margin: 15px;
    }

    .auth {
      border: 0.5px solid #adacac;
      border-radius: 30px;

      .label {
        display: inline-block;
        background-color: #3598dc;
        color: #fff;
        border-radius: 30px;
        width: 70px;
        text-align: center;
      }

      .code {
        margin-left: 5px;
      }

      .el-icon-copy-document {
        cursor: pointer;
        display: inline-block;
        width: 30px;
        text-align: center;
        float: right;
        line-height: 16px;

        &:hover {
          color: #3598dc;
        }
      }
    }
  }
</style>
